import Vue from "vue"


export function sendResizeEventNextTick() {
	Vue.nextTick(() => {
		sendResizeEvent();
	});
}

/**
 * Browser resize event that even IE understands.
 */
export function sendResizeEvent() {
	var resizeEvent = window.document.createEvent('UIEvents');
	//@ts-ignore
	resizeEvent.initUIEvent('resize', true, false, window, 0); 
	window.dispatchEvent(resizeEvent);
}


export function brandColor() {
	return getComputedStyle(document.documentElement)
    	.getPropertyValue('--brand-color');
}

export function trackColor() {
	return getComputedStyle(document.documentElement)
    	.getPropertyValue('--track-color');
}

export function setTrackColor(cssVar) {
	document.documentElement.style.setProperty('--track-color', getComputedStyle(document.documentElement).getPropertyValue(cssVar));
}

export function brandColorDark() {
	return getComputedStyle(document.documentElement)
    	.getPropertyValue('--brand-color-dark');
}

export function locationColor() {
	return getComputedStyle(document.documentElement)
    	.getPropertyValue('--location-color');
}

export function hexToArray(hex:string, alpha:number = 1) {
	hex = hex.trim();
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);
	const a = alpha * 255;
	return [r, g, b, a]
	
}


//mimics the implementation in mapbox
export function checkGeolocationSupport(callback) {
	if (window.navigator.permissions !== undefined) {
		window.navigator.permissions.query({name: 'geolocation'}).then((p) => {
			callback(p.state !== 'denied');
		});
		
	} else {
		callback(!!window.navigator.geolocation);
	}
}